import { type NodeProps } from '@xyflow/react';
import NodeMenu from 'automations/components/NodeMenu';
import { type SendWebengageEventNodeType } from 'automations/types/nodeSchemas/actionNodes';

import SendWebengageEventForm from './SendWebengageEventForm';

export default function SendWebengageEventContent({
  node,
}: {
  node: NodeProps<SendWebengageEventNodeType>;
}) {
  return (
    <NodeMenu
      node={node}
      drawerProps={{
        title: 'Action - Send WebEngage Event',
      }}
    >
      <SendWebengageEventForm node={node} />
    </NodeMenu>
  );
}
